import classNames from 'classnames';
var classes = {
    base: 'text-brand-01 transition-colors dark:text-white',
    size: {
        xs: 'text-xs',
        sm: 'text-sm',
        base: 'text-base',
        lg: 'text-lg',
        xl: 'text-xl',
        headline: 'headline',
    },
};
var Paragraph = function (_a) {
    var _b = _a.size, size = _b === void 0 ? 'base' : _b, children = _a.children, className = _a.className, _c = _a.bold, bold = _c === void 0 ? false : _c, _d = _a.center, center = _d === void 0 ? false : _d;
    return (<p className={classNames(classes.base, classes.size[size], bold && 'font-semibold', center && 'text-center', className)}>
      {children}
    </p>);
};
export default Paragraph;
